import React, { useContext, useEffect, useState } from 'react';
import { AuthenticateDocument } from './AuthenticateDocument';
import External from './Comp/ExternalUser';
import MainLayout from './Comp/MainLayout';
import { MindMapContext } from './Context/contex';

export default function App({ isExternal, isTemplateDocument = false }) {
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const { setIsTemplateDocument } = MindMapContext();

  useEffect(() => {
    setIsTemplateDocument(isTemplateDocument);
  }, []);


  if (isExternal) {
    return <External />;
  }
  else {
    if (isAuthenticating) { // isAuthenticating
      return <AuthenticateDocument setIsLoading={setIsAuthenticating} />
    }
    else {
      return <MainLayout />;
    }
  }
}
